<template>
	<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0)">
			<path
				d="M39.9999 1.77889e-07H5.00001C4.34334 -0.000175001 3.69308 0.129034 3.08638 0.380246C2.47967 0.631457 1.9284 0.999748 1.46407 1.46407C0.999748 1.9284 0.631457 2.47967 0.380246 3.08638C0.129034 3.69308 -0.000175001 4.34334 1.77889e-07 5.00001V39.9999C-0.000175001 40.6567 0.129034 41.307 0.380246 41.9136C0.631457 42.5203 0.999748 43.0716 1.46407 43.536C1.9284 44.0003 2.47967 44.3685 3.08638 44.6197C3.69308 44.871 4.34334 45.0002 5.00001 45H39.9999C40.6567 45.0002 41.307 44.871 41.9136 44.6197C42.5203 44.3685 43.0716 44.0003 43.536 43.536C44.0003 43.0716 44.3685 42.5203 44.6197 41.9136C44.871 41.307 45.0002 40.6567 45 39.9999V5.00001C45.0002 4.34334 44.871 3.69308 44.6197 3.08638C44.3685 2.47967 44.0003 1.9284 43.536 1.46407C43.0716 0.999748 42.5203 0.631457 41.9136 0.380246C41.307 0.129034 40.6567 -0.000175001 39.9999 1.77889e-07ZM17.5 35.0001L5.00001 22.5L8.52533 18.9746L17.5 27.924L36.4747 8.94934L39.9999 12.5L17.5 35.0001Z"
				fill="#365DF0"
			/>
		</g>
		<defs>
			<clipPath id="clip0">
				<rect width="45" height="45" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-check-box',
	components: {},
	computed: {},
	props: {}
};
</script>

<docs>
    IconCheckBox

    ```js
    <b-icon-check-box />
    ```
</docs>
